import React, { Component } from 'react'
import classNames from 'classnames/'
import PropTypes from 'prop-types'
import appContainer from '../../../container'
import styles from './clickOutside.module.scss'

class ClickOutside extends Component {
  constructor(props) {
    super(props)

    this.handleDocumentClick = this.handleDocumentClick.bind(this)
  }

  componentDidMount() {
    if (appContainer) {
      appContainer.addEventListener('click', this.handleDocumentClick)
    }
  }

  componentWillUnmount() {
    if (appContainer) {
      appContainer.removeEventListener('click', this.handleDocumentClick)
    }
  }

  handleDocumentClick(e) {
    const { onClickOutside } = this.props

    if (!this.clickContainer.contains(e.target) && onClickOutside)
      onClickOutside(e)
  }

  render() {
    const { className, children, block } = this.props

    const clickOutsideClass = classNames(styles.clickOutside, className, {
      [styles.block]: block
    })

    return (
      <div
        className={clickOutsideClass}
        ref={(node) => {
          this.clickContainer = node
        }}
      >
        {children}
      </div>
    )
  }
}

ClickOutside.defaultProps = {
  onClickOutside: null,
  className: null,
  children: null,
  block: false
}

ClickOutside.propTypes = {
  onClickOutside: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.string
  ]),
  block: PropTypes.bool
}

export default ClickOutside
